import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '@app/shared/services/auth.service';
import { WindowToken } from '@app/shared/window.token';

/**
 * Resume Parsing Base route guard to control the accessibility for ops tool setting 
 * `disableResumeParsingInOnboarding`
 */
@Injectable({
  providedIn: 'root',
})
export class ResumeParsingBaseGuard implements CanActivate {
  public isAuthorized: boolean = false;

  constructor(
    private authService: AuthService,
    protected router: Router,
    @Inject(WindowToken) private windowRef: Window
  ) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    const disableResumeParsing: boolean = this.authService.authUser
      ?.disableResumeParsingInOnboarding;

    if (disableResumeParsing) {
      this.router.navigateByUrl('/getstarted/welcome');
    }
    return !disableResumeParsing;
  }
}
